<template>
  <div class="article-swiper-module">
    <div class="top-articles-wrapper">
      <a :href="`http://www.geekpark.net/news/${article.id}`" class="a-link" target="_blank" v-for="(article, i) in topArticles" :key="i">
        <div class="article">
          <div class="title">{{article.title}}</div>
          <img class="avatar"
               :src="article.authors && article.authors.length > 0 ? article.authors[0].avatar_url : ''" alt="">
          <div class="content">{{article.abstract}}</div>
          <div class="time">{{article.published_timestamp | dateformat('MMM DD HH:mm')}}</div>
        </div>
      </a>
    </div>
    <div class="article-swiper-wrapper" @mousewheel.stop>
      <swiper id="line1" :options="SwiperOptions" class="article-swiper-1" ref="articleSwiper1">
        <swiper-slide v-for="(article, i) in line1Data" :key="i">
          <a :href="`http://www.geekpark.net/news/${article.id}`" target="_blank">
            <div class="article">
              <div class="title">{{article.title}}</div>
              <img class="avatar"
                   :src="article.authors && article.authors.length > 0 ? article.authors[0].avatar_url : ''" alt="">
              <div class="content">{{article.abstract}}</div>
              <div class="time">{{article.published_timestamp | dateformat('MMM DD HH:mm')}}</div>
            </div>
          </a>
        </swiper-slide>
      </swiper>
      <swiper id="line2" :options="SwiperOptions" class="article-swiper-2" ref="articleSwiper2">
        <swiper-slide v-for="(article, i) in line2Data" :key="i">
          <a :href="`http://www.geekpark.net/news/${article.id}`" target="_blank">
            <div class="article">
              <div class="title">{{article.title}}</div>
              <div class="content">{{article.abstract}}</div>
              <img class="avatar"
                   :src="article.authors && article.authors.length > 0 ? article.authors[0].avatar_url : ''" alt="">
              <div class="time">{{article.published_timestamp*1000 | dateformat('MMM DD, YYYY')}}</div>
            </div>
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArticleSwiper',
  props: {data: Array, topArticles: Array},
  methods: {},
  computed: {
    line1Data () {
      return this.data.slice(0, parseInt(this.data.length / 2))
    },
    line2Data () {
      return this.data.slice(parseInt(this.data.length / 2))
    }
  },
  data () {
    return {
      SwiperOptions: {
        // basic
        direction: 'vertical',
        nested: true,
        height: window.innerHeight,
        resistanceRatio: 0,
        // loop
        loop: true,
        loopedSlides: parseInt(this.data.length / 2),
        loopAdditionalSlides: parseInt(this.data.length / 2),
        // free
        freeMode: true,
        // grid
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        // mousewheel
        mousewheel: true
      }
    }
  },
  mounted () {
    const articleSwiper1 = this.$refs.articleSwiper1.swiper
    const articleSwiper2 = this.$refs.articleSwiper2.swiper
    // articleSwiper1.slideTo(80, 0, false)
    // articleSwiper2.slideTo(80, 0, false)
    this.$nextTick(() => {
      articleSwiper1.controller.control = articleSwiper2
      articleSwiper2.controller.control = articleSwiper1
    })
  }
}
</script>
<style lang="stylus" scoped>
.article-swiper-module
  width 540px
  height 100%
  overflow hidden
  .top-articles-wrapper
    position relative
    // border-bottom 1px solid rgba(255, 255, 255, 0.15)
    padding-bottom 15px
    margin-bottom 15px
    .a-link
      position relative
      display inline-block
      vertical-align top
      background rgba(255, 255, 255, 0.09)
      color #fff
      border-radius 10px
      width unit((@width - 20) / 2, 'px')
      text-decoration none
      &:last-child
        margin-left 20px
      .article
        text-align left
        .title
          margin-left 59px
          margin-top 15px
          height 36px
          font-size 12px
          line-height @height
          margin-bottom 14px
          padding-right 20px
          text-overflow ellipsis
          white-space nowrap
          overflow hidden
        .avatar
          position absolute
          top 15px
          left 15px
          width 36px
          height @width
          border-radius 50%
          background-color #fff
        .content
          width 230px
          margin 0 auto
          font-size 12px
          line-height 20px
          margin-bottom 15px
          height 60px
          overflow hidden
          text-overflow ellipsis
          display -webkit-box
          -webkit-box-orient vertical
          -webkit-line-clamp 3
        .time
          width 230px
          margin 0 auto
          font-size 12px
          line-height 17px
          margin-bottom 15px
  .swiper-container
    float left
    &#line2
      padding-left 20px
      .swiper-slide
        transform translate(0, unit(130 / 2, 'px'))
    .swiper-slide
      background rgba(255, 255, 255, 0.09)
      color #fff
      border-radius 10px
      width unit((@width - 20) / 2, 'px')
      a
        color #fff
        text-decoration none
      .article
        text-align left
        .title
          margin-left 59px
          margin-top 15px
          height 36px
          font-size 12px
          line-height @height
          margin-bottom 14px
          padding-right 20px
          text-overflow ellipsis
          white-space nowrap
          overflow hidden
        .avatar
          position absolute
          top 15px
          left 15px
          width 36px
          height @width
          border-radius 50%
          background-color #fff
        .content
          width 230px
          margin 0 auto
          font-size 12px
          line-height 20px
          margin-bottom 15px
        .time
          width 230px
          margin 0 auto
          font-size 12px
          line-height 17px
          margin-bottom 15px
</style>



// WEBPACK FOOTER //
// src/components/ArticleSwiper.vue